'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ImageModal = _react2['default'].createClass({
    displayName: 'ImageModal',


    propTypes: {
        'imagePath': _react2['default'].PropTypes.string
    },

    componentDidMount: function componentDidMount() {
        $(document).foundation();
        $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
    },

    render: function render() {
        return _jsx('img', {
            src: this.props.imagePath
        });
    }
});

module.exports = ImageModal;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api-docs/image-modal.jsx
 ** module id = 735
 ** module chunks = 0
 **/